import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import(
      './viewer/LanguageSelector' /* webpackChunkName: "LanguageSelector" */
    ),
    import(
      './viewer/LanguageSelector.controller' /* webpackChunkName: "LanguageSelector" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('LanguageSelector', UiTypes),
};

export default entry;
